<template>
  <div class="developer-availability">
    <h3 class="developer-availability__title">Availability</h3>

    <v-form class="developer-availability__content">
      <v-row>
        <v-col class="developer-availability__col">
          <v-select
            v-model="currentAvailability.status"
            class="developer-availability__select form-field"
            :items="featuresData.availability"
            dense
            item-color="blue"
            label="Type"
            placeholder="Choose type"
          />
        </v-col>
      </v-row>

      <v-row v-if="isAvailableWithDateLimit">
        <v-col class="developer-availability__dates">
          <v-menu
            ref="menuDateFrom"
            content-class="datepicker-menu"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
          >
            <template v-slot:activator="{ on }">
              <div class="form-field--date-wrapper" v-on="on">
                <v-text-field
                  v-model="currentAvailability.from"
                  class="form-field mr-2"
                  label="From"
                  placeholder="Chose date"
                  dense
                  readonly
                  v-on="on"
                >
                  <template #append>
                    <v-icon color="blue">
                      mdi-calendar
                    </v-icon>
                  </template>
                </v-text-field>
              </div>
            </template>
            <v-date-picker
              v-model="currentAvailability.from"
              no-title
              scrollable
              :max="currentAvailability.to"
              @input="$refs.menuDateFrom.save(true)"
            ></v-date-picker>
          </v-menu>

          <v-menu
            ref="menuDateTo"
            content-class="datepicker-menu"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
          >
            <template v-slot:activator="{ on }">
              <div class="form-field--date-wrapper" v-on="on">
                <v-text-field
                  v-model="currentAvailability.to"
                  class="form-field ml-2"
                  label="To"
                  placeholder="Chose date"
                  dense
                  readonly
                  v-on="on"
                >
                  <template #append>
                    <v-icon color="blue">
                      mdi-calendar
                    </v-icon>
                  </template>
                </v-text-field>
              </div>
            </template>
            <v-date-picker
              v-model="currentAvailability.to"
              no-title
              scrollable
              :min="currentAvailability.from"
              @input="$refs.menuDateTo.save(true)"
            ></v-date-picker>
          </v-menu>
        </v-col>
      </v-row>

      <v-row v-if="isAvailabilityChanged">
        <v-col class="developer-availability__col">
          <v-btn
            class="fw-400"
            color="blue"
            medium
            dark
            :loading="isSubmitProcessing"
            @click="saveChanges"
          >
            SAVE CHANGE
          </v-btn>
        </v-col>
      </v-row>
    </v-form>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { areObjectsDifferent } from '@/helpers/utils';
import validationRules from '@/helpers/validators';

const rules = validationRules;

export default {
  data() {
    return {
      rules,
      currentAvailability: {
        status: '',
        from: '',
        to: '',
      },
    };
  },

  computed: {
    ...mapState('hrDeveloper', [
      'developer',
      'isSubmitProcessing',
    ]),

    ...mapState('features', [
      'featuresData',
    ]),

    isAvailabilityChanged() {
      return areObjectsDifferent(this.currentAvailability, this.developer.availability);
    },

    isAvailableWithDateLimit() {
      return this.currentAvailability.status === 'Available with limit';
    },
  },

  watch: {
    developer: {
      handler() {
        this.currentAvailability = { ...this.developer.availability };
      },
      deep: true,
    },
  },

  methods: {
    ...mapActions('hrDeveloper', [
      'updateDeveloper',
    ]),

    saveChanges() {
      this.updateDeveloper({ availability: this.currentAvailability });
    },
  },
};
</script>

<style lang="scss" scoped>
.developer-availability {
  margin-bottom: 24px;
  padding: 16px 24px;
  background: #FFFFFF;
  box-shadow: 0px 3px 6px #00000029;
  border-radius: 8px;

  &__title {
    color: $color--primary;
    font-size: 18px;
    line-height: 21px;
    font-weight: 500;
    margin-bottom: 16px;
  }

  &__dates {
    display: flex;
    align-items: center;
    justify-content: center;
    padding-top: 0;
  }

  &__col {
    padding-top: 0;
  }

  &__select {
    max-width: 64%;
  }
}
</style>
